import { AssetOverviewDataContext } from 'features/assetDatabase/contexts/AssetOverviewDataLayer'
import { AssetOverviewUXContext } from 'features/assetDatabase/contexts/AssetOverviewUXLayer'
import { useGeckoLocale } from 'features/locale'
import { useGeckoPermissions } from 'features/permissions'
import React, { forwardRef, useContext } from 'react'
import styled from 'styled-components'
import { SortTableByField } from 'types'
import { parseToReactElement } from 'utils/parsingHelpers'

import { FeatureForm } from './FeatureForm'

const MessageAndTable = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0.375rem;
  background-color: ${({ theme }) => theme.forecast.cardGroupBackground};
  overflow: hidden;
`

const StyledTableMessage = styled.div`
  width: 100%;
  padding: 0.5rem;
  border-bottom: solid 1px
    ${({ theme }) => theme.forecast.cardDividerBackground};
  color: ${({ theme }) => theme.forecast.defaultText};
  background-color: ${({ theme }) => theme.forecast.cardGroupBackground};
  cursor: default;

  a {
    color: ${({ theme }) => theme.forecast.defaultText};
  }
`

const TableContainer = styled.div`
  overflow-x: auto;
`

interface FeatureTableProps {
  componentID: string
  tableMessage: string | undefined
  featureType: string
  inEditMode: boolean
  inResolveMode: boolean
  sortBy: SortTableByField[]
  deletedFeatures: string[]
}

export const FeatureTable = forwardRef<HTMLFormElement, FeatureTableProps>(
  (
    {
      componentID,
      tableMessage,
      featureType,
      sortBy,
      inEditMode,
      inResolveMode,
      deletedFeatures,
    },
    ref
  ) => {
    const { assetDataObj, refreshData } = useContext(AssetOverviewDataContext)
    const { handleSaveToRolodex, handleFeatureDelete, handleFeatureDuplicate } =
      useContext(AssetOverviewUXContext)
    const { permissions } = useGeckoPermissions()
    const { measurementSystem } = useGeckoLocale()
    return (
      <>
        <MessageAndTable>
          {tableMessage ? (
            <StyledTableMessage>
              <span>{parseToReactElement(tableMessage)}</span>
            </StyledTableMessage>
          ) : undefined}
          <TableContainer>
            {assetDataObj && permissions && assetDataObj.assetModel && (
              <FeatureForm
                assetDataObj={assetDataObj}
                ref={ref}
                assetModel={assetDataObj.assetModel}
                sortBy={sortBy}
                featureType={featureType}
                componentID={componentID}
                measurementSystem={measurementSystem}
                inEditMode={inEditMode}
                inResolveMode={inResolveMode}
                forceRefresh={refreshData}
                handleFeatureDuplicate={handleFeatureDuplicate}
                handleFeatureDelete={handleFeatureDelete}
                userPermissions={permissions}
                handleSaveToRolodex={handleSaveToRolodex}
                deletedFeatures={deletedFeatures ?? []}
              />
            )}
          </TableContainer>
        </MessageAndTable>
      </>
    )
  }
)

FeatureTable.displayName = 'FeatureTable'
